import useTag from "@casino/legacy/client/hooks/feature/useTag";
import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import getUnitName from "./helpers/getUnitName";

/**
 * The wallet currency's config, fetched on the server by `PagesRouterAdapter`
 * for the user's wallet currency.
 */
const useCurrencyConfig = () => {
  const { currencyConfig } = useAppContext();
  const isUbtcEnabled = useTag("uBTC");
  if (!currencyConfig?.name) {
    return {} as CashierConfig;
  }
  const { name, type } = currencyConfig;
  const newNode = {
    ...currencyConfig,
    icon: name, //Todo get icon from config
    type: type === "banking" ? "fiat" : "coin",
    unit: getUnitName(name, isUbtcEnabled),
  };
  return newNode as CashierConfig;
};

export default useCurrencyConfig;
